import React, { useEffect, useState } from 'react'
import styles from './HeaderSelect.module.scss'
import CrmSelect from '@components/ui/CrmSelect/CrmSelect'
import WeekSelect from '@components/ui/WeekSelect/WeekSelect'
import { useGetCrmList } from '@api/useCrmApi'
import { Input, Select } from 'antd'
import { useDebounce } from '@hooks/useDebounce'
import { expensesReasonMapper } from '@utils/mappers'
import { ExpensesReason } from '@dto/salary/expenses.dto'
import cn from 'classnames'

const { Option } = Select

interface Props {
  setSelectedWeek: React.Dispatch<React.SetStateAction<string[]>>
  crmSelectHandler: (e: string[]) => void
  selectedWeek: string
  setIsAllCrms?: React.Dispatch<React.SetStateAction<boolean>>
  crmInit?: string[]
  setSearch?: (search: string) => void
  setExpansesType?: (type: ExpensesReason) => void
  className?: string
}

const HeaderSelect: React.FC<Props> = ({
  setSelectedWeek,
  crmSelectHandler,
  selectedWeek,
  setIsAllCrms,
  crmInit,
  setSearch,
  setExpansesType,
  className,
}) => {
  const { crmsLight, isLoading } = useGetCrmList()
  const [input, setInput] = useState<string>()
  const searchReq = useDebounce(input, 500)

  useEffect(() => {
    setSearch && setSearch(searchReq)
  }, [searchReq, setSearch])

  return (
    <>
      <div className={cn(styles.container, className)}>
        <div className={styles.column}>
          <CrmSelect
            title='Выберите CRM:'
            crmsLight={crmsLight}
            isLoading={isLoading}
            onChange={crmSelectHandler}
            initialValue={crmInit?.length ? crmInit : ['all']}
            className={styles.crmSelect}
            setIsAllCrms={setIsAllCrms}
          />
          <WeekSelect title='Выберите неделю:' onChange={setSelectedWeek} value={selectedWeek} />
        </div>
        <div className={styles.column}>
          {setExpansesType && (
            <Select
              allowClear
              className='customSelect'
              placeholder='Выберите расход'
              style={{ width: '100%' }}
              onChange={(e) => setExpansesType && setExpansesType(e)}
              getPopupContainer={() => document.getElementById('App') || document.body}
            >
              {Object.values(ExpensesReason).map((el) => (
                <Option value={el} key={el}>
                  {expensesReasonMapper(el as ExpensesReason)}
                </Option>
              ))}
            </Select>
          )}
          {setSearch && (
            <Input
              className={styles.search}
              placeholder='Поиск'
              onChange={(e) => setInput(e?.target?.value)}
              value={input}
              allowClear
            />
          )}
        </div>
      </div>
    </>
  )
}

export default HeaderSelect
